/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
const _="ESRI__ID",I="ESRI__OriginID",t="ESRI__DestID",S="ESRI__LayoutGeometry",o="ESRI__AggregationCount",E="LC.ESRI__IsSpatial";export{o as systemAggregationCountFieldName,t as systemDestinationIdFieldName,E as systemIsSpatialFieldName,S as systemLayoutGeometryFieldName,_ as systemOidFieldName,I as systemOriginIdFieldName};
